import { type IAppointmentSuggestion } from '@principle-theorem/principle-core/interfaces';
import { type EntityModel } from '@principle-theorem/shared';

export type AppointmentSuggestionEntity = EntityModel<IAppointmentSuggestion>;
